import {initializeFinancialPartnerApp} from '../shared/initializeFinancialPartnerApp';

initializeFinancialPartnerApp({
  partnerExpressUrl: 'https://static-na.payments-amazon.com/cPSPcheckout.js',
});
